import { CircleCheckBig } from 'lucide-react';

import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';
import { hasValue } from 'utils/hasValue';

import { TENANT } from 'constants/environment';

import type { CurrencyCode } from 'api/customerApi';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

type Props = {
  successfulExchangeAmount?: string;
  onNewExchange: () => void;
  toCurrency?: CurrencyCode;
};

export const ExchangeSuccessView = ({
  successfulExchangeAmount,
  onNewExchange,
  toCurrency
}: Props) => {
  return (
    <div className="flex min-h-[480px] flex-col justify-between gap-6 rounded-2xl bg-white p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <CircleCheckBig className="text-content-positive" size={64} />
        <div className="text-2xl font-semibold text-content-primary">
          Transaction successful!
        </div>
        {hasValue(successfulExchangeAmount) && (
          <div className="text-lg text-content-primary">
            {`${successfulExchangeAmount} ${toCurrency}`} will be credited to
            your account shortly!
          </div>
        )}
        <div className="max-w-xl text-sm text-content-secondary">
          Transactions made by 12:00 PM CET, Monday to Friday (excluding
          weekends and holidays) will have the equivalent euro credited to your
          {capitalizeFirstLetter(TENANT)} account on the same day.
        </div>
      </div>
      <PrimaryButton className="w-full" onClick={onNewExchange}>
        New exchange
      </PrimaryButton>
    </div>
  );
};
